import { FC, ReactElement } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { routes } from '@router/index';
import { RazorPayLogo } from '@components/common/svg-icons';
import Header from './header';

const Layout: FC = (): ReactElement => {
  const location = useLocation();
  // const { token, step } = useSelector((state: RootState) => state.login);
  return (
    <div className="relative flex h-screen w-full flex-col">
      {location.pathname !== routes[0].path && <Header />}

      <section className="flex-1 overflow-y-auto bg-gray-100">
        <Outlet />
      </section>

      <div className="fixed bottom-4 right-4 flex items-center gap-1 rounded bg-white/80 px-2 py-1 shadow">
        <span className="text-sm text-gray-600">Powered by</span>
        <RazorPayLogo />
      </div>
    </div>
  );
};

export default Layout;
